let Raven = null;

if (process.env.NODE_ENV !== 'test') {
  if (__SERVER__) {
    Raven = require('raven');
  } else {
    Raven = require('raven-js');
  }
}

export default (ex, extra, logger = 'wma-flightstats-com') => {
  console.info('report-exception', logger, ex, extra);
  if (process.env.NODE_ENV === 'test') {
    // no op
  } else if (__DEVELOPMENT__) {
    console.log('would have sent exception to Sentry', ex);
  } else if (__SERVER__) {
    Raven.captureException(ex, { logger, extra }, (sendErr, eventId) => {
      // This callback fires once the report has been sent to Sentry
      if (sendErr) {
        console.error('Failed to send captured exception to Sentry with error:', sendErr, 'Original exception:', ex);
      } else {
        console.log(`Captured exception and send to Sentry successfully for event ${eventId}`);
      }
    });
  } else {
    const newExtra = extra || {};

    newExtra.error = ex;
    Raven.captureException(ex, { logger, extra: newExtra });
  }
};



// WEBPACK FOOTER //
// ./shared/lib/report-exception/index.js